module.exports = __webpack_public_path__ + "static/media/img-devteam-page-mobile.65ff48ff.png";